import urls from '@/constants/endpoints/gateway';
import {
    ScheduleTrackerDTO,
    ScheduleTrackerRequestDetails,
    ScheduleTrackerRequestDetailsDTO,
    ScheduleTrackerRequestsCountDTO,
    ScheduleTrackerRequestsFiltersModel,
    VendorProposalsCount,
} from '@/types/gatewayDataModels';

import httpApi from './httpApi_new';

class ScheduleTrackerRequestsService {
    getScheduleTrackerRequests = ({
        queryParams,
        data,
    }: {
        queryParams: {page?: number; size?: number; sort: string | string[]};
        data: ScheduleTrackerRequestsFiltersModel;
    }): Promise<ScheduleTrackerDTO> =>
        httpApi.post<ScheduleTrackerDTO>({
            url: urls.GET_SCHEDULE_TRACKER_REQUESTS,
            queryParams,
            data,
        });

    getScheduleTrackerRequestsCount = (): Promise<ScheduleTrackerRequestsCountDTO> =>
        httpApi.get({
            url: urls.GET_SCHEDULE_TRACKER_REQUESTS_COUNT,
        });

    getVendorProposalsCount = (): Promise<VendorProposalsCount> =>
        httpApi.get<VendorProposalsCount>({
            url: urls.GET_VENDOR_PROPOSALS,
        });

    getScheduleTrackerRequestDetails = (data: ScheduleTrackerRequestDetailsDTO) =>
        httpApi.get<ScheduleTrackerRequestDetails>({
            url: urls.GET_SCHEDULE_TRACKER_REQUEST_DETAILS(data?.id),
        });

    acknowledgeScheduleTrackerAlerts = ({itemId}: {itemId: string}) =>
        httpApi.put({
            url: urls.ACKNOWLEDGE_SCHEDULE_TRACKER_ALERTS(itemId),
        });

    acceptVendorProposal = ({itemId, proposalId}: {itemId: string; proposalId: number}) =>
        httpApi.put({
            url: urls.ACCEPT_VENDOR_PROPOSAL(itemId),
            data: {proposalId},
        });

    rejectVendorProposal = ({itemId}: {itemId: string}) =>
        httpApi.put({
            url: urls.REJECT_VENDOR_PROPOSAL(itemId),
        });
}

const scheduleTrackerRequestsService = new ScheduleTrackerRequestsService();
export default scheduleTrackerRequestsService;
